/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { Widget } from 'features/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { AudienceTimelineWidget as AudienceTimelineWidgetType } from 'schemas/AudienceTimelineWidgetSchema'
import { getLabel } from 'utils/widgetTypeUtil'

import Timeline from '../../share/TopicsMode/Timeline'
import TopicsModeWidgetDataGuards from '../../share/TopicsMode/guards/TopicsModeWidgetDataGuards'
import { WidgetLoadingGuard } from '../../../share/guards'
import WidgetSettingGuards from './guards/WidgetSettingGuards'
import RunSearchEffect from './searches/RunSearchEffect'
import useSelectedInsights from '../share/InsightModal/hooks/useSelectedInsights'
import InsightModal from '../share/InsightModal'

const AudienceTimelineWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<AudienceTimelineWidgetType>(widgetId)
  const {
    isModalOpen,
    onClick,
    onClickChart,
    onSelection,
    onClose,
    selectedInsights,
    widgetSettingWithSelectedInsights
  } = useSelectedInsights(widgetSetting)

  return (
    <UnexpectedErrorBoundary>
      <WidgetSettingGuards widgetId={widgetId}>
        <RunSearchEffect widgetId={widgetId}>
          <WidgetLoadingGuard widgetId={widgetId}>
            <TopicsModeWidgetDataGuards widgetId={widgetId}>
              <Timeline
                widgetId={widgetId}
                onClickPoint={onClick}
                onClickChart={onClickChart}
                onSelection={onSelection}
              />
            </TopicsModeWidgetDataGuards>
          </WidgetLoadingGuard>
        </RunSearchEffect>
      </WidgetSettingGuards>
      <InsightModal
        title={
          widgetSettingWithSelectedInsights?.name ||
          getLabel(widgetSettingWithSelectedInsights?.type)
        }
        open={isModalOpen}
        onClose={onClose}
        selectedInsights={selectedInsights}
        widgetSetting={widgetSettingWithSelectedInsights}
        isAudienceQuery
      />
    </UnexpectedErrorBoundary>
  )
}

export default AudienceTimelineWidget
